import '.ag{position:relative;}.ssr-plugin'
import '.cb{display:inline-flex;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.e9{align-self:flex-start;}.ssr-plugin'
import '.ea{padding:3px;}.ssr-plugin'
import '.eb{background:var(--palette-blue-50);}.ssr-plugin'
import '.ec{border:0.5px solid var(--gray-200);}.ssr-plugin'
import '.d1{border-radius:0.75rem;}.ssr-plugin'
import '.ba{position:absolute;}.ssr-plugin'
import '.ed{top:3px;}.ssr-plugin'
import '.bn{left:0px;}.ssr-plugin'
import '.ee{width:0px;}.ssr-plugin'
import '.ef{height:calc(100% - 6px);}.ssr-plugin'
import '.eg{background:var(--palette-white);}.ssr-plugin'
import '.eh{border:0.5px solid var(--gray-300);}.ssr-plugin'
import '.ei{border-radius:calc(0.75rem - 3px);}.ssr-plugin'
import '.ej{box-shadow:0 1px 3px rgba(0, 0, 0, 0.08);}.ssr-plugin'
import '.cn{pointer-events:none;}.ssr-plugin'
import '.ek{z-index:1;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.af{justify-content:center;}.ssr-plugin'
import '.el{gap:0.375rem;}.ssr-plugin'
import '.em{padding-block:6px;}.ssr-plugin'
import '.en{padding-inline:18px;}.ssr-plugin'
import '.d5{background:transparent;}.ssr-plugin'
import '.c4{border:none;}.ssr-plugin'
import '.a1{cursor:pointer;}.ssr-plugin'
import '.da{user-select:none;}.ssr-plugin'
import '.eo{white-space:nowrap;}.ssr-plugin'
import '.ax{flex:1;}.ssr-plugin'
import { useCallback, useLayoutEffect, useRef } from 'react'
import { Style, styled } from 'inlines'
import { Text } from '../typography/Text'

export type ToggleOption<T> = {
  label: string
  value: T
  style?: Style
}

export type ToggleProps<T> = {
  options: ToggleOption<T>[]
  selectedOption: T
  setSelectedOption: (option: T) => void
  style?: Style
}

const PILL_TRANSITION =
  'left 0.28s cubic-bezier(0.34, 1.3, 0.64, 1), width 0.28s cubic-bezier(0.34, 1.3, 0.64, 1)'

export const Toggle = <T extends string | boolean>({
  options,
  selectedOption,
  setSelectedOption,
  style,
}: ToggleProps<T>) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const pillRef = useRef<HTMLDivElement>(null)
  const itemRefs = useRef<(HTMLButtonElement | null)[]>([])

  const updatePill = useCallback(() => {
    const selectedIndex = options.findIndex(
      (option) => option.value === selectedOption,
    )
    const activeEl = itemRefs.current[selectedIndex]
    const pill = pillRef.current

    if (!activeEl || !pill) {
      return
    }

    pill.style.left = `${activeEl.offsetLeft}px`
    pill.style.width = `${activeEl.offsetWidth}px`
  }, [options, selectedOption])

  useLayoutEffect(() => {
    const container = containerRef.current
    if (!container) {
      return
    }

    updatePill()

    const observer = new ResizeObserver(() => {
      updatePill()
    })
    observer.observe(container)

    return () => observer.disconnect()
  }, [updatePill])

  return (
    <styled.div className="ag cb t e9 ea eb ec d1"
      ref={containerRef}
      style={{
        ...style,
      }}
    >
      <div className="ba ed bn ee ef eg eh ei ej cn"
        ref={pillRef}
        aria-hidden="true"
        style={{
          transition: PILL_TRANSITION,}}
      />
      {options.map((option, index) => {
        const isActive = selectedOption === option.value

        return (
          <styled.button className="ag ek d t af el em en d5 c4 ei a1 da eo ax"
            key={String(option.value)}
            type="button"
            ref={(element) => {
              itemRefs.current[index] = element
            }}
            onClick={() => setSelectedOption(option.value)}
            style={{
              ...(!isActive && {
                '&:hover span': {
                  color: 'var(--brand-secondary)',
                },
              }),
              ...option.style,
            }}
          >
            <Text.Medium
              color={
                isActive
                  ? 'var(--brand-secondary)'
                  : 'var(--palette-blue-400)'
              }
              isBold={isActive}
              style={{ transition: 'color 0.18s' }}
            >
              {option.label}
            </Text.Medium>
          </styled.button>
        )
      })}
    </styled.div>
  )
}
